<template>
  <div class="history-chart-warp">
    <div class="history-chart" :ref="`history-${chartId}`" :class="[statusClass]"></div>
    <div v-if="useHumiditySectionLine" class="history-ts">适用湿度范围 {{ range }}</div>
  </div>
</template>
<script type="text/babel">
export default {
  props: {
    series: Array,
    xAxisData: Array,
    legendData: Array,
    useHumiditySectionLine: Boolean,
    humiditySectionLineMax: Number,
    range: String,
    statusClass: String,
    isHumidityPercentage: Boolean,
    chartTitle: String,
    seperateTemperatureYAxis: Boolean,
    specialHourXAxis: Boolean,
  },
  watch: {
    series() {
      if (this.isHumidityPercentage) {
        this.setOptions_humidityPercentage();
      } else {
        this.setOptions();
      }
    },
    chartTitle() {
      if (this.isHumidityPercentage) {
        this.setOptions_humidityPercentage();
      } else {
        this.setOptions();
      }
    },
    seperateTemperatureYAxis() {
      this.historyChart.dispose();
      this.historyChart = this.$echarts.init(this.$refs[`history-${this.chartId}`]);

      if (this.isHumidityPercentage) {
        this.setOptions_humidityPercentage();
      } else {
        this.setOptions();
      }
    },
  },
  computed: {
    isHumidityChart() {
      let result = false;
      for (let seriesItem of this.series) {
        if (seriesItem.name.indexOf("湿度") >= 0) {
          result = true;
          break;
        }
      }

      return result;
    },
    specialHourXAxisLabelList() {
      if (!this.xAxisData) {
        return [];
      }

      let maxDisplayLabelCount = 16;

      let result = [];
      let targetHourList = ["02时", "08时", "14时", "20时"];
      for (let label of this.xAxisData) {
        for (let hour of targetHourList) {
          if (label.indexOf(hour) >= 0) {
            result.push(label);
            break;
          }
        }
      }

      if (result.length > maxDisplayLabelCount) {
        let trimResult = [];
        let needRemoveCount = result.length - maxDisplayLabelCount;

        // if (needRemoveCount < maxDisplayLabelCount * 2) {
        if (false) {
          debugger;
          //pick label to remove
          let removeRate = result.length / needRemoveCount;
          let removeRateFraction = removeRate - Math.floor(removeRate);
          if(removeRateFraction > 0.5){
            removeRateFraction = removeRateFraction - 0.5;
          }
          let removeIndex = 0;
          for (let i = 0; i < result.length; i++) {
            removeIndex++;
            if (removeIndex >= removeRate) {
              removeIndex = removeIndex - Math.floor(removeIndex) + removeRateFraction;
              continue;
            } else {
              trimResult.push(result[i]);
            }
          }
        } else {
          //pick label to insert
          let insertRate = result.length / maxDisplayLabelCount;
          let insertIndex = 0;
          trimResult.push(result[0]);
          for (let i = 1; i < result.length; i++) {
            insertIndex++;
            if (insertIndex >= insertRate) {
              insertIndex = 0;
              trimResult.push(result[i]);
            } else {
              continue;
            }
          }
        }

        return trimResult;
      }

      return result;
    },
  },
  data() {
    return {
      historyChart: null,
      chartId: "",
      seriesActual: [],
    };
  },
  created() {
    this.chartId = (new Date().getTime() % 7568) + Math.floor(Math.random() * 67467576);
  },
  mounted() {
    this.init();
    window.addEventListener("resize", () => {
      if (!this.historyChart.isDisposed) {
        this.historyChart.resize();
      }
    });
  },
  methods: {
    init() {
      this.historyChart = this.$echarts.init(this.$refs[`history-${this.chartId}`]);
      this.historyChart.showLoading();
    },
    setOptions_humidityPercentage() {
      const $this = this;
      let title = "设备湿度比例数据";
      if (this.chartTitle) {
        title = this.chartTitle;
      }
      const option = {
        title: { text: title },
        // color: [
        //   '#FB3611',
        //   '#1A2634',
        //   '#449187',
        //   '#d48265',
        //   '#118DEF',
        //   '#92E4A6',
        //   '#F35F5F',
        //   '#FFCC01',
        //   '#6e7074',
        //   '#546570',
        //   '#c4ccd3',
        // ],
        tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        legend: {
          type: "scroll",
          data: this.legendData,
          bottom: "0",
          right: "5px",
          // selectedMode: false,
          textStyle: { color: "#000" },
          icon: "bar",
        },
        grid: {
          left: "10px",
          right: "30px",
          top: "50px",
          bottom: "30px",
          containLabel: true,
        },
        xAxis: { type: "category", axisTick: { show: false }, data: this.xAxisData },
        yAxis: {
          type: "value",
          max: 100,
          min: 0,
        },
        series: this.series,
      };

      this.historyChart.hideLoading();
      this.historyChart.setOption(option);
    },
    setOptions() {
      const $this = this;

      let unitNormalList = [];
      let valueNormal = [];
      let valueTemperature = [];
      this.seriesActual = [];
      this.series.forEach((item) => {
        if (this.seperateTemperatureYAxis && item.name.indexOf("温度") >= 0 && item.name.indexOf("℃") >= 0) {
          //右侧温度y轴
          let temperatureItem = {
            ascription: item.ascription,
            data: item.data,
            name: item.name,
            type: item.type,
            yAxisIndex: 1,
          };

          this.seriesActual.push(temperatureItem);
          valueTemperature.push(...item.data);
        } else {
          //左侧正常y轴
          this.seriesActual.push(item);
          valueNormal.push(...item.data);

          let unit = this.getUnitFromName(item.name);
          unitNormalList.push(unit);
        }
      });

      let unitNormal = "";
      let distinctUnitNormalList = this.distinctList(unitNormalList);
      if (distinctUnitNormalList.length === 1) {
        unitNormal = distinctUnitNormalList[0];
      }
      if (unitNormal === "无" || unitNormal === "运行时间") {
        unitNormal = "";
      }

      let yAxisNormal = {
        type: "value",
        max: function (value) {
          if ($this.isHumidityChart) {
            //湿度图固定0-100
            return 100;
          } else {
            let sectionLine = 0;
            if ($this.useHumiditySectionLine) {
              sectionLine = $this.humiditySectionLineMax;
            }

            return $this.calculateYAxisMax(valueNormal, sectionLine);
          }
        },
        axisLabel: {
          formatter: unitNormal === "" ? "{value}" : "{value} " + unitNormal,
        },
      };
      let yAxisTemperature = {
        type: "value",
        max: function (value) {
          return $this.calculateYAxisMax(valueTemperature);
        },
        axisLabel: {
          formatter: "{value} ℃",
        },
      };

      let yAxis = {};
      if (this.seperateTemperatureYAxis) {
        yAxis = [yAxisNormal, yAxisTemperature];
      } else {
        yAxis = yAxisNormal;
      }

      let title = "历史数据查询";
      if (this.chartTitle) {
        title = this.chartTitle;
      }

      let xAxisLabel = { interval: "auto" };
      if (this.specialHourXAxis) {
        xAxisLabel.interval = this.axisInterval;
      }
      
      const option = {
        title: { text: title },
        //  color: ['#545e8c', '#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#213784', '#ca8622', '#bda29a'],
        color: ["#FB3611", "#1A2634", "#449187", "#d48265", "#118DEF", "#92E4A6", "#F35F5F", "#FFCC01", "#6e7074", "#546570", "#c4ccd3"],
        tooltip: { trigger: "axis" },
        legend: {
          type: "scroll",
          data: this.legendData,
          bottom: "0",
          right: "5px",
          // selectedMode: false,
          textStyle: { color: "#000" },
          icon: "bar",
        },
        grid: {
          left: "10px",
          right: "30px",
          top: "50px",
          bottom: "30px",
          containLabel: true,
        },
        xAxis: { type: "category", boundaryGap: false, data: this.xAxisData, axisLabel: xAxisLabel },
        yAxis: yAxis,
        series: this.seriesActual,
      };

      this.historyChart.hideLoading();
      this.historyChart.setOption(option);
    },
    axisInterval(index, value) {
      if (this.specialHourXAxisLabelList.indexOf(value) >= 0) {
        return true;
      } else {
        return false;
      }
    },
    calculateYAxisMax(value, sectionLine) {
      sectionLine = sectionLine || 0;

      let cha = sectionLine - Math.max(...value);
      let result = Math.max(...value) + (cha > 0 ? cha : 0) + 5;
      result = Math.ceil(result);
      // console.log(value);
      // console.log(Math.max(...value));
      // console.log(result);
      return result;
    },
    getUnitFromName(name) {
      if (name.length >= 3 && name[name.length - 1] === ")") {
        let startIndex = name.lastIndexOf("(");
        if (startIndex >= 0 && name.length - startIndex <= 5) {
          let result = name.substring(startIndex + 1, name.length - 1).trim();
          return result;
        }
      }
      return "";
    },
    distinctList(list) {
      let result = [];
      list.forEach((item) => {
        if (result.indexOf(item) < 0) {
          result.push(item);
        }
      });

      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.history-chart-warp {
  width: 100%;
  height: 100%;
  position: relative;
}

.history-ts {
  position: absolute;
  width: 160px;
  text-align: center;
  font-size: 12px;
  color: #666;
  top: 15px;
  left: 50%;
  margin-left: -80px;
}

.history-chart {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
}
</style>
